// Single source of truth for "this value has nothing to show" across the
// compact mobile company-detail tree. Numeric 0 and boolean false are valid
// data, never treated as empty.
export const isEmptyValue = (value) => {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') return value.trim().length === 0;
    if (Array.isArray(value)) return value.length === 0;
    return false;
};

export const hasAnyValue = (values) => values.some((v) => !isEmptyValue(v));
